import { useMutation, useQuery, useQueryClient } from "react-query";
import { parseCookies } from "nookies";
import { GetprofileData } from "@/api/functions/user.api";
import { logout, setLoginData } from "@/reduxtoolkit/slices/userSlice";
import { useAppDispatch } from "./useAppDispatch";
import { useAppSelector } from "./useAppSelector";
import { useSnackbar } from "notistack";
import axiosInstance from "@/api/axiosInstance";
import { endpoints } from "@/api/endpoints";

const useUser = () => {
  const cookies = parseCookies();
  const token = cookies?.token;
  const dispatch = useAppDispatch();
  const { userData } = useAppSelector((s) => s.userSlice);

  const profileDetails = useQuery("userdetails", GetprofileData, {
    enabled: !!token && userData === null,
    onSuccess(data) {
      if (data?.status === 200) {
        dispatch(setLoginData(data?.data));
      } else {
        dispatch(logout());
      }
    },
    onError(err) {
      dispatch(logout());
    },
  });

  // const profileUpdateMutation = useMutation({
  //   mutationKey: "profileUpdate",
  //   mutationFn: ProfileUpdateMutation,
  // });

  return {
    profileDetails,
    //  profileUpdateMutation
  };
};

//   export const useSearchList = () => {
//     const cookies = parseCookies();

//     const { userData } = useAppSelector((s) => s.userSlice);

//     const list = useQuery(["searchListQuery",userData], searchListQuery, {
//       enabled: userData !== null,
//     });

//     return list;
//   };

export const useUpdateProfile = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(
    async (put) => {
      return axiosInstance
        .put(endpoints.auth.profileUpdate1, put)
        .then(({ data }) => {
          enqueueSnackbar(data?.message, { variant: "success" });
          return data;
        });
    },
    {
      onSuccess: () => {
        queryClient.refetchQueries("userdetails");
      },
    }
  );
};


// change password admin
export const useChangePasswordAdmin = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(
    async (post) => {
      return axiosInstance
        .post(endpoints.auth.changePasswordAdmin, post)
        .then(({ data }) => {
          enqueueSnackbar(data?.message, { variant: "success" });
          return data;
        });
    },
    {
      onSuccess: () => {
        queryClient.refetchQueries("changePasswordAdmin");
      },
    }
  );
};

export default useUser;






